export const DEFAULT_TRUNCATE_LENGTH = 500;
export const POST_CONTENT_TRUNCATE_LENGTH = DEFAULT_TRUNCATE_LENGTH;
export const COMMENT_CONTENT_TRUNCATE_LENGTH = DEFAULT_TRUNCATE_LENGTH;

export const HIGHLIGHT_TIMEOUT = 5000;
